module.exports = __webpack_public_path__ + "static/waves-3458a8e63cf03321b1b0779a4ad31221.svg";